import { Component, OnInit, Input, ViewChild, Output, EventEmitter, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { InnerLookupComponent } from './inner-lookup-component/inner-lookup.component';
import { BaseInputDirective } from '../base-input.directive';
import { LookupType } from '../../../lookup/generic-lookup/lookup-type';
import { GenericEntitySearchType } from '../../../dialog/generic-entity-search/generic-entity-search-type';
import { GenericLookupResult } from '../../../lookup/generic-lookup/generic-lookup';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-lookup-input',
  templateUrl: './lookup-input.component.html',
  styleUrls: ['./lookup-input.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA], 
  imports:[
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    InnerLookupComponent,
    MatFormFieldModule,
  ],    
})
export class LookupInputComponent extends BaseInputDirective implements OnInit {
  @Input() lookupType: LookupType;
  @Input() lookupTypes: LookupType[];
  @Input() queryObject?: object;
  @Input() disableLink: boolean;
  @Input() searchType: GenericEntitySearchType;
  @ViewChild(InnerLookupComponent) innerLookup: InnerLookupComponent;
  @Output() dataChanges = new EventEmitter<GenericLookupResult>();
  hideInnerLookup = false;

  
 


  onDataChanges(result: GenericLookupResult) {
    this.dataChanges.emit(result);
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.lookupType && this.searchType) {
      throw new Error('lookupType and searchType are mutually-exclusive input properties.');
    }
  }

  updateAssociatedData(data: GenericLookupResult) {
    if (data.lookupType) {
      this.lookupType = data.lookupType;
    }
    this.innerLookup.updateAssociatedData(data, data.lookupType);
  }
}
